export default "__VITE_ASSET__BoY9DpWv__"